export const routesHandler = {
  home: {
    key: 'home',
    name: 'Home',
    path: '/',
  },
  search: {
    key: 'search',
    name: 'Search',
    path: '/search',
  },
  sites: {
    key: 'sites',
    name: 'Sites',
    path: '/search/sites',
  },
  cart: {
    key: 'cart',
    name: 'Cart',
    path: '/cart',
  },
  details: {
    key: 'details',
    name: 'Details',
    path: '/details',
  },
  payment: {
    key: 'payment',
    name: 'Payment',
    path: '/checkout',
  },
  confirmation: {
    key: 'confirmation',
    name: 'Confirmation',
    path: '/confirmation/:uuid',
  },
}
